module.exports = __webpack_public_path__ + "static/media/020_v1_notifications.ff1432c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/020_v1_notifications.png
// module id = 399
// module chunks = 0